import Component from "@glimmer/component";
import { action } from "@ember/object";
import { arg, forbidExtraArgs } from "glesys-controlpanel/utils/arg";

@forbidExtraArgs
export default class LoadBalancerTarget extends Component {
  @arg servers;
  @arg target;

  get loadBalancer() {
    return this.target.listener.get("loadBalancer");
  }

  get hostname() {
    let serversMatchingTargetIp = [];
    let hostname = this.servers.filter((server) => {
      for (const ip of server.ipsVersion4) {
        if (ip.address == this.target.ipaddress) {
          serversMatchingTargetIp.push(server.hostname);
        }
      }
      for (const ip of server.ipsVersion6) {
        if (ip.address == this.target.ipaddress) {
          serversMatchingTargetIp.push(server.hostname);
        }
      }
      return serversMatchingTargetIp.includes(server.hostname);
    });
    return hostname.length > 0 ? hostname[0].hostname : "";
  }

  get ips() {
    return this.servers
      .filter((server) => server.ipsVersion4.length > 0 || server.ipsVersion6.length > 0)
      .map((server) => {
        let options = server.ipsVersion4
          .map((ip) => ({ value: ip.address }))
          .concat(server.ipsVersion6.map((ip) => ({ value: ip.address })));

        return {
          label: server.hostname,
          options,
        };
      });
  }

  @action
  updateTargetIpFromServer(event) {
    this.target.ipaddress = event.target.value;
  }

  onIpChange = (event) => (this.target.ipaddress = event.target.value);

  onPortChange = (event) => (this.target.port = parseInt(event.target.value));

  onWeightChange = (event) => (this.target.weight = parseInt(event.target.value));

  @action
  activeChange(event) {
    this.target.active = event.target.checked;
  }

  @action
  deleteTarget() {
    let target = this.target;

    if (target.get("isDeleted")) {
      target.rollbackAttributes();
    } else {
      target.deleteRecord();
    }
  }
}
